import React from "react";
import { Modal } from "@mui/material";

const InvoiceModal = ({ open, onClose, imageUrl }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div
        className="bg-white p-6 rounded-lg shadow-lg w-[95%] sm:w-[600px] lg:w-[800px] max-h-[90vh] flex flex-col"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Invoice</h2>
        </div>

        {/* Content area with scroll */}
        <div className="flex-1 overflow-y-auto">
          <img src={imageUrl} alt="Invoice" className="w-full h-auto mb-4" />
        </div>

        {/* Footer with button bottom-right */}
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default InvoiceModal;
